import type { ChangeEvent, CSSProperties } from 'react';
import type { IToggleSwitch } from './ToggleSwitch.interface';
import { classNameForElement, StyleElement, styleForElement } from './ToggleSwitch.style';

function ToggleSwitch(properties: IToggleSwitch): JSX.Element {
    const style = (element: StyleElement, overrides?: CSSProperties) =>
        styleForElement(element, properties, overrides);
    const className = (element: StyleElement, overrides?: string) =>
        classNameForElement(element, properties, overrides);

    const onChange = (event: ChangeEvent<HTMLInputElement>) => {
        properties.onCheck?.(event.target.checked);
    };

    return (
        <div
            className={className(StyleElement.Container, properties.className)}
            style={style(StyleElement.Container, properties.style)}
        >
            <input
                aria-label={properties.description}
                type={'checkbox'}
                className={className(StyleElement.Checkbox)}
                style={style(StyleElement.Checkbox)}
                checked={properties.isOn ?? false}
                onChange={onChange}
            />
            <label
                aria-hidden="true"
                className={className(StyleElement.Label)}
                style={style(StyleElement.Label)}
            >
                {properties.description ?? ''}
            </label>
        </div>
    );
}

export default ToggleSwitch;
